// Jedyne zrodlo prawdy o danych firmy (NAP), cenach i przebiegu diagnozy.
//
// WAZNE: kazda strona, stopka, schema JSON-LD i sitemap czerpia dane STAD.
// Nie wpisuj adresu, telefonu ani ceny bezposrednio w komponencie - popraw tutaj,
// wdroz przez `./deploy.sh` (bez przestoju) i zmiana pojawi sie w calym serwisie naraz.
//
// Pola oznaczone [DO POTWIERDZENIA] to wartosci robocze - potwierdz je przed
// wysylka strony do indeksacji.

export const SITE_URL = 'https://sensorini.pl';

/* ------------------------------------------------------------------ *
 * NAP - jedna kanoniczna tozsamosc firmy (spec sekcja 5)
 * ------------------------------------------------------------------ */
export const FIRMA = {
  nazwa: 'Sensorini Anna Serwińska',
  nazwaKrotka: 'Sensorini',
  osoba: 'Anna Serwińska',
  rola: 'Diagnosta i terapeutka integracji sensorycznej',
  ulica: 'ul. Partyzantów 31/5',
  kod: '10-526',
  miasto: 'Olsztyn',
  wojewodztwo: 'warmińsko-mazurskie',
  kraj: 'PL',
  telefon: '663 518 937',
  telefonE164: '+48663518937',
  email: 'anna@sensorini.pl',
  url: SITE_URL,
  // Wspolrzedne zweryfikowane wzgledem adresu Partyzantow 31 w Olsztynie.
  lat: 53.78399452910102,
  lng: 20.491745113017462,
  // [DO POTWIERDZENIA] godziny przyjec - trafiaja do JSON-LD i na /kontakt/
  godziny: [{ dni: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], od: '09:00', do: '18:00' }],
  godzinyTekst: 'poniedziałek - piątek, 9:00-18:00 (wizyty po wcześniejszym umówieniu)',
};

export const ADRES_PELNY = `${FIRMA.ulica}, ${FIRMA.kod} ${FIRMA.miasto}`;
export const MAPS_QUERY = encodeURIComponent(`${FIRMA.nazwaKrotka}, ${ADRES_PELNY}`);
export const MAPS_LINK = `https://www.google.com/maps/search/?api=1&query=${MAPS_QUERY}`;
export const MAPS_EMBED = `https://www.google.com/maps?q=${MAPS_QUERY}&output=embed`;
export const MAPS_NAV = `https://www.google.com/maps/dir/?api=1&destination=${MAPS_QUERY}`;

/* ------------------------------------------------------------------ *
 * Cennik (spec sekcja 10)
 *
 * `null` = kwota nieustalona. Strona pokazuje wtedy uczciwe "cena ustalana
 * indywidualnie" zamiast zmyslonej liczby. Wpisz kwote w zlotowkach (liczba),
 * a cena pojawi sie na /cennik/, na stronie diagnozy i w danych strukturalnych.
 * ------------------------------------------------------------------ */
export const CENNIK = {
  diagnoza: {
    nazwa: 'Diagnoza integracji sensorycznej',
    cena: 400,
    jednostka: 'całość procesu diagnostycznego',
    zawiera: [
      'wywiad z rodzicem dotyczący rozwoju i codziennego funkcjonowania dziecka',
      'kwestionariusz sensomotoryczny wypełniany przed spotkaniem',
      'próby obserwacji klinicznej oraz testy dostosowane do wieku dziecka',
      'omówienie wyników z rodzicem',
      'pisemną opinię z wnioskami i zaleceniami do pracy w domu',
    ],
  },
  konsultacja: {
    nazwa: 'Konsultacja dla rodzica',
    cena: null, // [DO POTWIERDZENIA]
    jednostka: 'spotkanie ok. 50 minut',
    zawiera: [
      'rozmowa o niepokojących objawach bez pełnego procesu diagnostycznego',
      'wstępne wskazówki i informacja, czy diagnoza SI jest w ogóle zasadna',
    ],
  },
  terapia: {
    nazwa: 'Terapia integracji sensorycznej',
    cena: 120,
    jednostka: 'zajęcia indywidualne, 45 minut',
    zawiera: [
      'zajęcia indywidualne prowadzone według planu ustalonego po diagnozie',
      'bieżące wskazówki dla rodzica po zajęciach',
    ],
  },
  // [DO POTWIERDZENIA] zasady organizacyjne
  odwolanie: 'Wizytę można odwołać bezpłatnie najpóźniej 24 godziny przed terminem. Późniejsze odwołanie lub nieobecność bez zgłoszenia oznacza naliczenie pełnej opłaty za zarezerwowany termin.',
  platnosci: 'Płatność gotówką lub przelewem po spotkaniu.',
  faktura: 'Na życzenie wystawiam rachunek za wykonaną usługę - poproś o niego przy umawianiu wizyty.',
};

/** Sformatowana cena albo uczciwy komunikat zastepczy. */
export const cenaTekst = (poz) =>
  typeof poz.cena === 'number' ? `${poz.cena} zł` : 'cena ustalana indywidualnie';

/* ------------------------------------------------------------------ *
 * Przebieg diagnozy - odpowiedzi na pytania wymagane przez spec sekcja 1
 * [DO POTWIERDZENIA] w calosci
 * ------------------------------------------------------------------ */
export const DIAGNOZA = {
  wiek: 'Pełną diagnozę integracji sensorycznej przeprowadzam u dzieci od 4. roku życia - wcześniej wiarygodne wykonanie testów jest trudne. Młodsze dzieci, w tym niemowlęta, zapraszam na konsultację i obserwację rozwoju sensomotorycznego.',
  wiekOd: 4,
  wiekDo: 12,
  spotkania: 1,
  spotkaniaTekst: 'Diagnoza odbywa się podczas jednego spotkania w gabinecie: przeprowadzam wywiad z rodzicem i badanie dziecka. Wyniki omawiam po przygotowaniu pisemnej opinii - osobiście albo telefonicznie.',
  // [DO POTWIERDZENIA] czas trwania jednej wizyty. Wczesniej byly tu dwa
  // spotkania po ok. 60 minut; przy jednej wizycie obejmujacej wywiad i
  // badanie ta liczba wymaga potwierdzenia, wiec na stronie nie pada.
  czasSpotkania: '',
  wywiad: 'Tak. Wywiad z rodzicem jest częścią diagnozy i odbywa się na tym samym spotkaniu, przed badaniem dziecka - rozmawiamy o przebiegu ciąży, porodu, rozwoju ruchowego i o codziennych trudnościach.',
  narzedzia: 'Korzystam z Testów Południowo-Kalifornijskich (u dzieci od 4. roku życia), z prób obserwacji klinicznej oraz z obserwacji dziecka w swobodnej i zaplanowanej aktywności ruchowej. Uzupełnieniem jest kwestionariusz sensomotoryczny wypełniany przez rodzica przed wizytą.',
  // Zakres badania - przeniesiony z wycofanej strony /diagnoza-si
  narzedziaLista: [
    'wywiad z opiekunem: przebieg ciąży, porodu i pierwszych lat rozwoju, kamienie milowe (ruch, poznanie, mowa), stan zdrowia dziecka',
    'Testy Południowo-Kalifornijskie (głównie od 4. roku życia): planowanie ruchu, różnicowanie wrażeń dotykowych, naśladownictwo ruchowe, równowaga, koordynacja wzrokowo-ruchowa',
    'obserwacja kliniczna: lateralizacja, odruchy, napięcie mięśniowe, praca gałek ocznych, poziom pobudzenia układu przedsionkowego',
    'obserwacja w działaniu: reakcje dziecka podczas zadań ruchowych z użyciem specjalistycznego sprzętu',
    'pisemna opinia z omówieniem wyników i zaleceniami dla rodziców oraz placówki',
  ],
  opinia: 'Tak. Rodzic otrzymuje pisemną opinię z opisem wyników, wnioskami i zaleceniami do pracy w domu, przedszkolu lub szkole.',
  czasOpinii: 'Opinię przygotowuję do 14 dni od badania i omawiam ją osobiście lub telefonicznie.',
  coZabrac: 'Wygodny strój i skarpetki antypoślizgowe dla dziecka, książeczkę zdrowia, a także wcześniejsze opinie i wyniki badań, jeśli dziecko było już diagnozowane (psycholog, logopeda, neurolog, fizjoterapeuta, okulista, audiolog). Warto też wcześniej odświeżyć sobie przebieg ciąży, porodu i pierwszych lat rozwoju oraz zanotować, co najbardziej utrudnia dziecku codzienny dzień - o to zapytam na wywiadzie.',
  obecnoscRodzica: 'Wywiad prowadzę z rodzicem. Podczas badania dziecko pracuje ze mną samodzielnie - rodzic czeka w poczekalni, ponieważ obecność bliskiej osoby zwykle zmienia zachowanie dziecka. Przy dzieciach młodszych lub bardzo lękliwych ustalamy to indywidualnie.',
  jakUmowic: 'Zadzwoń pod 663 518 937, napisz na anna@sensorini.pl albo wypełnij kwestionariusz sensomotoryczny online - odezwę się i wspólnie ustalimy termin.',
};

/* ------------------------------------------------------------------ *
 * Terapia (spec sekcja 7) - [DO POTWIERDZENIA]
 * ------------------------------------------------------------------ */
export const TERAPIA = {
  dlaKogo: 'Terapia jest dla dzieci, u których diagnoza wykazała trudności w przetwarzaniu bodźców zmysłowych - przejawiające się nadwrażliwością, podwrażliwością, słabą koordynacją, trudnościami z planowaniem ruchu albo z utrzymaniem uwagi.',
  czyDiagnoza: 'Tak, terapię poprzedza diagnoza. Bez niej nie wiadomo, które układy zmysłowe wymagają wsparcia, a ćwiczenia dobrane "na oko" nie mają podstaw.',
  plan: 'Plan terapii powstaje na podstawie wyników diagnozy. Zapisuję w nim cele na najbliższe miesiące, rodzaje aktywności i wskazówki do pracy w domu.',
  czasZajec: 'Zajęcia trwają 45 minut.',
  czestotliwosc: 'Najczęściej raz lub dwa razy w tygodniu - częstotliwość ustalam indywidualnie po diagnozie.',
  postepy: 'Postępy omawiam z rodzicem na bieżąco, a co kilka miesięcy wracamy do prób z diagnozy, żeby porównać wyniki i zaktualizować plan.',
  rodzic: 'Rodzic dostaje po zajęciach konkretne wskazówki do domu. Regularne, krótkie aktywności w domu mają na efekty co najmniej taki wpływ jak same zajęcia w gabinecie.',
  zastrzezenie: 'Efekty terapii zależą od indywidualnych potrzeb dziecka, regularności spotkań i współpracy z rodzicami. Nie obiecuję konkretnego rezultatu ani terminu jego osiągnięcia.',
};

/* ------------------------------------------------------------------ *
 * Dojazd i dostepnosc (spec sekcja 27 + wymagane pytania z sekcji 1)
 * [DO POTWIERDZENIA]
 * ------------------------------------------------------------------ */
export const DOJAZD = {
  dzielnica: 'Gabinet mieści się w centrum Olsztyna, przy ul. Partyzantów - kilka minut spacerem od dworca Olsztyn Główny i od Starego Miasta.',
  komunikacja: 'Dojazd autobusem do przystanków przy ul. Partyzantów oraz w okolicy dworca Olsztyn Główny; z dworca PKP/PKS dojście zajmuje ok. 10 minut.',
  parking: 'Przed budynkiem i w bocznych uliczkach dostępne są miejsca parkingowe w strefie płatnego parkowania. Warto doliczyć kilka minut na znalezienie miejsca.',
  wejscie: 'Wejście od ul. Partyzantów, lokal nr 5. Przy drzwiach znajduje się domofon - zadzwoń pod numer lokalu, a otworzę.',
  dostepnosc: 'Przed wizytą z wózkiem lub przy ograniczonej mobilności dziecka zadzwoń pod 663 518 937 - opiszę dokładnie dojście do gabinetu i pomogę wejść.',
  obszar: 'Przyjmuję dzieci z Olsztyna oraz z okolic - m.in. z gmin Dywity, Jonkowo, Stawiguda, Purda, Gietrzwałd i Barczewo.',
};
